var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "w100" },
        [
          _c(
            "w-breadcrumb",
            { attrs: { crumbs: _vm.path } },
            [
              _c("w-spacer"),
              _vm.$wf.isMdUp
                ? _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    [
                      _vm.DecimalSettings
                        ? _c(
                            "w-card",
                            [
                              _c("w-card-title", [
                                _vm._v(_vm._s(_vm.$ct("decimals"))),
                              ]),
                              _c(
                                "w-card-content",
                                [
                                  _c(
                                    "w-row",
                                    [
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12" } },
                                        [
                                          _c("w-checkbox", {
                                            attrs: {
                                              label: _vm.$ct(
                                                "use-comma-seperator"
                                              ),
                                            },
                                            model: {
                                              value:
                                                _vm.DecimalSettings
                                                  .UseCommaSeperator,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.DecimalSettings,
                                                  "UseCommaSeperator",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "DecimalSettings.UseCommaSeperator",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-row",
                                    [
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12" } },
                                        [
                                          _c("w-input-number", {
                                            attrs: {
                                              decimals: 0,
                                              fancy: "",
                                              label:
                                                _vm.$ct("decimals-for-qty"),
                                              "calculated-decimals": 0,
                                              min: "0",
                                              max: "8",
                                            },
                                            model: {
                                              value: _vm.DecimalSettings.Qty,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.DecimalSettings,
                                                  "Qty",
                                                  $$v
                                                )
                                              },
                                              expression: "DecimalSettings.Qty",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12" } },
                                        [
                                          _c("w-input-number", {
                                            attrs: {
                                              decimals: 0,
                                              fancy: "",
                                              label:
                                                _vm.$ct("decimals-for-qty2"),
                                              "calculated-decimals": 0,
                                              min: "0",
                                              max: "8",
                                            },
                                            model: {
                                              value: _vm.DecimalSettings.Qty2,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.DecimalSettings,
                                                  "Qty2",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "DecimalSettings.Qty2",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12" } },
                                        [
                                          _c("w-input-number", {
                                            attrs: {
                                              decimals: 0,
                                              fancy: "",
                                              label:
                                                _vm.$ct("decimals-for-unit"),
                                              "calculated-decimals": 0,
                                              min: "0",
                                              max: "8",
                                            },
                                            model: {
                                              value: _vm.DecimalSettings.Unit,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.DecimalSettings,
                                                  "Unit",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "DecimalSettings.Unit",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12" } },
                                        [
                                          _c("w-input-number", {
                                            attrs: {
                                              decimals: 0,
                                              fancy: "",
                                              label:
                                                _vm.$ct("decimals-for-buy"),
                                              "calculated-decimals": 0,
                                              min: "0",
                                              max: "8",
                                            },
                                            model: {
                                              value: _vm.DecimalSettings.Buy,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.DecimalSettings,
                                                  "Buy",
                                                  $$v
                                                )
                                              },
                                              expression: "DecimalSettings.Buy",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12" } },
                                        [
                                          _c("w-input-number", {
                                            attrs: {
                                              decimals: 0,
                                              fancy: "",
                                              label:
                                                _vm.$ct("decimals-for-bruto"),
                                              "calculated-decimals": 0,
                                              min: "0",
                                              max: "8",
                                            },
                                            model: {
                                              value: _vm.DecimalSettings.Bruto,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.DecimalSettings,
                                                  "Bruto",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "DecimalSettings.Bruto",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12" } },
                                        [
                                          _c("w-input-number", {
                                            attrs: {
                                              decimals: 0,
                                              fancy: "",
                                              label:
                                                _vm.$ct("decimals-for-sale"),
                                              "calculated-decimals": 0,
                                              min: "0",
                                              max: "8",
                                            },
                                            model: {
                                              value: _vm.DecimalSettings.Sale,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.DecimalSettings,
                                                  "Sale",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "DecimalSettings.Sale",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }